module.exports = __webpack_public_path__ + "img/obs-cor.1aba883d.png";